const MESSAGES = {
    groups: {
        noGroups: `You don't have any Naviance Test Prep groups assigned to you.`,
        noGroupsForFilter: `There are no groups assigned to this combination of instructor and
        grade. Please make other selections.`,
        noDistrictPermission: `Sorry, you don't have the permission needed to view this page. Please
        review your permissions or contact your Naviance Administrator.`
    },
    students: {
        noStudents: `You don't have any students assigned to this group.`,
        noStudentsForStatus: `No students matched the status selected.`
    },
    assignedPrograms: {
        successMessageOne: `student group has been successfully assigned study programs.`,
        successMessageMultiple: `student groups have been successfully assigned study programs.`     
    },
    manageDefaults: {
        successMessage: `Success! Your default group preferences have been saved.`
    }
};

export interface MessageObject { [name: string]: string; }
export interface MessagingService { (component: string): MessageObject; }

export function messagingService() {
    return (component: string) => MESSAGES[component];
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/messaging/messaging.service.ts
 **/